import { z } from 'zod'

/** Zod rule for comma-separated CDR tags stored as a string in forms and API payloads. */
export const cdrTagsSchema = z.string().max(255).nullable().optional().or(z.literal(''))

/** Parse API/form comma-separated CDR tags into a taggable multi-select value. */
export function parseCdrTags(value: string | null | undefined): string[] {
  if (!value) return []

  return value
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean)
}

/** Serialize taggable multi-select values into comma-separated CDR tags for forms. */
export function formatCdrTags(tags: string[] | null | undefined): string {
  if (!Array.isArray(tags) || tags.length === 0) return ''

  return tags
    .map((tag) => tag.trim())
    .filter(Boolean)
    .join(',')
}
